<template>
<div class="help-center-entry" @click.stop="onClickHelpCenterEntry">
  <span>?</span>
  <div v-if="entryGuideShown" class="guide-popover arrow-box">
    <div class="text">如需要更多帮助，可在此处找到我们</div>
    <div class="button-row">
      <div class="btn" @click="popoverConfirm">知道了</div>
    </div>
  </div>
  <div v-if="helpCenterShown" class="help-center-popover" :style="{height: shownStage === 'outline' ? '330px' : ''}">
    <helpCenter></helpCenter>
  </div>
</div>
</template>

<script>
import {mapGetters} from 'vuex';
import helpCenter from './helpCenter.vue';
export default {
  components: {
    helpCenter
  },
  computed: {
    ...mapGetters({
      entryGuideShown: 'helpCenter/entryGuideShown',
      helpCenterShown: 'helpCenter/popoverShown',
      shownStage: 'helpCenter/shownStage'
    })
  },
  created () {
    window.addEventListener('click', this.onClickWindow);
  },
  beforeDestroy() {
    window.removeEventListener('click', this.onClickWindow);
  },
  methods: {
    popoverConfirm () {
      this.$store.commit('helpCenter/setEntryGuideShown', false);
    },
    onClickHelpCenterEntry () {
      this.$store.commit('helpCenter/setPopoverShown', true);
    },
    onClickWindow () {
      if (this.shownStage.indexOf('tutorialContent') < 0) {
        this.$store.commit('helpCenter/setPopoverShown', false);
      }
      this.$bus.emit("subtitlePopupClose", {
        name: "shortcuts",
        type: 1
      });
    }
  }
}
</script>

<style scoped lang="scss">
.help-center-entry {
  position: absolute;
  bottom: 30px;
  left: calc(50% - 18px);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 48px;
  background-color: #fff;
  cursor: pointer;

  & > span:first-child {
    font-size: 20px;
    font-weight: bold;
  }

  .guide-popover {
    position: absolute;
    left: calc(100% + 14px);
    bottom: -18px;
    width: 290px;
    height: 144px;
    background:
      url(../../../assets/vipTrialMessage/bg-guide-popover.png) right top/218px 123px no-repeat,
      linear-gradient(180deg, #FFEBFC 0%, #EFF4FF 35%, #FFFFFF 100%)
      ;
    box-shadow: 0px 4px 8px rgba(0,0,0,0.1600);
    opacity: 1;
    border-radius: 4px;
    cursor: default;
    font-size: 14px;
    font-weight: 400;
    cursor: default;
    .text {
      font-weight: 800;
      padding-top: 33px;
      padding-bottom: 33px;
    }
    .button-row {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 126px;
      height: 38px;
      background: #5778FB;
      opacity: 1;
      border-radius: 4px;
      color: #fff;
      &:hover {
        background-color: #7d95f5;
        cursor: pointer;
      }
    }
  }
  .arrow-box:after {
    right: 100%;
    bottom: 24px;
    border: solid transparent;
    content: "";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-color: rgba(136, 183, 213, 0);
    border-right-color: #fff;
    border-width: 12px;
  }

  .help-center-popover {
    position: absolute;
    left: calc(100% + 6px);
    bottom: 0;
    width: 244px;
    height: 368px;
    background: #FFFFFF;
    box-shadow: 0px 0px 4px rgba(5,30,109,0.1200);
    opacity: 1;
    border-radius: 4px;
    cursor: default;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/resourcesArea/helpCenter/helpCenterEntry.vue